(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alvar-offer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('a[href*="checkout-ds24.com"],a[href*="digistore24.com"]');if(!a)return;e.preventDefault();var h=a.href,d=false;function go(){if(!d){d=true;location.href=h}}if(typeof fbq==='function'){fbq('track','AddToCart',{content_name:'Masterclass'});fbq('track','InitiateCheckout',{content_name:'Masterclass'})}setTimeout(go,1200);fetch(Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:44628918206523,quantity:1}]})}).then(go,go)},true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
